import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const DeviceShow = lazy(() => import('../../container/pages/devices/show'));
const DeviceAll = lazy(() => import('../../container/pages/devices/all-index'));
const DeviceActivities = lazy(() => import('../../container/pages/devices/activities'));

function DevicesRoutes() {
  return (
    <Routes>
      <Route path="/*" element={<DeviceAll />} />
      <Route path="/show/:id/*" element={<DeviceShow />} />
      <Route path="/activities/:id" element={<DeviceActivities />} />
    </Routes>
  );
}

export default DevicesRoutes;
